var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-progress-linear',{attrs:{"color":_vm.mapStatusToColor(_vm.serviceStatus),"value":_vm.progress,"absolute":"","bottom":""}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }